import {base} from "@base-provider";
import {API_PARAM} from "../constants/apiParams";

export const uploadAsset = async (data, skillsPathId) => {
  return base.postFile({url: API_PARAM.ASSET_UPLOAD.replace("{id}", skillsPathId), data});
};

export const getBackgrounds = async () => {
  return base.get({url: API_PARAM.BACKGROUNDS});
};